import { makeStyles } from '@material-ui/core';
import { createFactoryStyles } from '../../../ui/styles/helpers';
export const useStyles = makeStyles(() => {
    return createFactoryStyles({
        variableListItem: {
            overflowY: 'auto',
        },
    });
});
